import {
  Box,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputLeftAddon,
  InputProps,
  InputRightElement,
  Text
} from '@chakra-ui/react'
import { ErrorMessage, FieldProps } from 'formik'
import * as React from 'react'
import { Eye, EyeOff } from 'react-feather'
import { Label, LabelProps } from '../styles'

export type ConnectedFormGroupProps = LabelProps &
  FieldProps &
  InputProps & {
    label?: string
  }

const ConnectedFormGroup: React.FC<ConnectedFormGroupProps> = ({
  type,
  label,
  field,
  placeholder,
  ...rest
}) => {
  const [show, setShow] = React.useState(false)
  const handleClick = () => setShow(!show)
  return (
    <Flex flexDirection="column" width="100%" mr={rest.mr} ml={rest.ml} mt={rest.mt} mb={rest.mb}>
      {label && <Label htmlFor={field.name}>{label}</Label>}
      <InputGroup size="md">
        <InputLeftAddon
          children={<Box width="1px" height="100%"></Box>}
          bg="white"
          border="none"
          padding="4px"
        />
        <Input
          {...field}
          id={field.name}
          focusBorderColor="brand.500"
          type={show ? 'text' : 'password'}
          placeholder={placeholder || label}
          paddingX={12}
          {...rest}
          mb={0}
        />
        <InputRightElement width="4.5rem">
          <IconButton
            background="transparent"
            h="1.75rem"
            size="sm"
            onClick={handleClick}
            aria-label="Show/Hide Password"
            icon={show ? <EyeOff /> : <Eye />}
          />
        </InputRightElement>
      </InputGroup>
      <ErrorMessage name={field.name}>
        {(msg) => (
          <Text mt="4px" ml="8px" color="intent.error">
            {msg}
          </Text>
        )}
      </ErrorMessage>
    </Flex>
  )
}

export default ConnectedFormGroup

ConnectedFormGroup.defaultProps = {
  mb: 2,
  type: 'text'
}
